// extracted by css-extract-rspack-plugin
export default {"cls1":"AvatarCell-cls1_CMY","cls2":"AvatarCell-cls2_0lY AvatarCell-cls1_CMY"};